<div class="question-with-options">
  <h1 class="title_42">
    <span class="title__stage">{{ question | translate }}</span>
  </h1>
  <div class="question-with-options__list">
    <span class="options-title">{{ optionsTitle | translate }}</span>
    @for (option of options; track option.id) {
      <mat-checkbox
        [class]="'form-radio-button-input w-100'"
        [checked]="isSelected(option.id)"
        (change)="toggleOption(option.id)"
      >
        <span class="checbox-text">{{ option.name }}</span>
      </mat-checkbox>
    }
  </div>
</div>
